let store = undefined;
// 解决循环依赖
export const setStore = (_store) => store = _store;
export const getStore = () => store;
